import React, { useState, useId, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { sendPasswordResetEmail } from 'firebase/auth'
import { firebaseAuth } from '../firebase/firebaseClient'
import Loader from '../components/Loader'
import Button from '../components/UI/button'
import Input from '../components/UI/input'
import { useTranslation } from 'react-i18next'

const ForgotPassword = () => {
	const uid = useId()
	const emailId = `fp-email-${uid}`
	const msgId = `fp-msg-${uid}`

	const { t, i18n } = useTranslation()
	const isFr = i18n.resolvedLanguage === 'fr'

	const toggleLanguage = () => {
		const nextLang = isFr ? 'en' : 'fr'
		i18n.changeLanguage(nextLang)
		localStorage.setItem('lang', nextLang)
	}

	useEffect(() => {
		const savedLang = localStorage.getItem('lang')
		if (savedLang) i18n.changeLanguage(savedLang)
	}, [])

	const [email, setEmail] = useState('')
	const [message, setMessage] = useState('')
	const [messageType, setMessageType] = useState('')
	const [loading, setLoading] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		setMessage('')
		setMessageType('')
		try {
			await sendPasswordResetEmail(firebaseAuth, email, {
				url: `${window.location.origin}/`,
			})
			setMessage(t('forgotPassword.successMsg'))
			setMessageType('success')
		} catch (error) {
			setMessage(t('forgotPassword.errorMsg'))
			setMessageType('error')
		}
		setLoading(false)
	}

	return (
		<>
			{loading ? (
				<Loader />
			) : (
				<div
					className="custom-container forgot-password-page"
					style={{ position: 'absolute', width: '100%', left: '0px' }}
				>
					<button
						type="button"
						className={`lang-switch ${isFr ? 'fr' : 'en'}`}
						onClick={toggleLanguage}
					>
						<span className="lang-switch-circle">{isFr ? 'FR' : 'EN'}</span>
					</button>

					<form
						className="left forgot-password-form"
						onSubmit={handleSubmit}
						aria-describedby={message ? msgId : undefined}
					>
						<div className="auth-card">
							<h1>{t('forgotPassword.header')}</h1>
							<p className="auth-subtext">{t('forgotPassword.subtext')}</p>

							{message && (
								<p
									id={msgId}
									className={`form-message ${messageType}`}
									role="status"
									aria-live="polite"
								>
									{message}
								</p>
							)}

							<label htmlFor={emailId} className="visually-hidden">
								{t('forgotPassword.placeholder')}
							</label>
							<Input
								id={emailId}
								name="email"
								type="email"
								placeholder={t('forgotPassword.placeholder')}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
								autoComplete="email"
							/>

							<div className="submit-btn-wrapper full-width">
								<Button variant="secondary" type="submit" size="lg">
									{t('forgotPassword.sendLink')}
								</Button>
							</div>

							<Link to="/" className="other-page-link">
								{t('forgotPassword.backToLogin')}
							</Link>
						</div>
					</form>

					<div className="right forgot-password-right">
						<h1>{t('forgotPassword.rightTitle')}</h1>
						<p>{t('forgotPassword.rightText')}</p>
						<div className="submit-btn-wrapper">
							<Link to="/">
								<Button variant="secondary" type="button" size="lg">
									{t('login.header')}
								</Button>
							</Link>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default ForgotPassword